//bao migrate skip
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialog from "./../../factories/bao-dialog";
class ServiceComponentDialogViewModel {
    Bao = Bao;
    Dialog: BaoDialog;
    ServiceLevelAgreementServiceCategoryId: KnockoutObservable<string> = ko.observable("");
    CustomerId: KnockoutObservable<string>;
    SelectedServiceCategory: KnockoutObservable<string>;
    JobDateJs: KnockoutObservable<string>;
    RealAmount: KnockoutObservable<Boolean>;
    TotalPrice: KnockoutObservable<number>;
    Price: KnockoutObservable<number>;
    Amount: KnockoutObservable<number>;
    SelectedAccountAssignmentType: KnockoutObservable<any> = ko.observable(null);
    AccountAssignmentTypeId: KnockoutObservable<string>;
    AccountAssignmentTypeName: KnockoutObservable<string>;
    MonthCollection: KnockoutObservableArray<number> = ko.observableArray([]);
    YearCollection: KnockoutObservableArray<number> = ko.observableArray([]);
    AccountAssignmentTypeCollection: KnockoutObservableArray<any> = ko.observableArray([]);
    AccountAssignment: KnockoutObservable<string>;
    BillingTypeName: KnockoutObservable<string>;
    BillingTypeId: KnockoutObservable<string>;
    BillingRhythmId: KnockoutObservable<string>;
    ServiceLevelAgreementName: KnockoutObservable<string>;
    ServiceLevelAgreementId: KnockoutObservable<string>;
    ServiceProviderName: KnockoutObservable<string>;
    ServiceProviderId: KnockoutObservable<string>;
    ServiceCategoryName: KnockoutObservable<string>;
    ServiceCategoryId: KnockoutObservable<string>;
    ActivityNumber: KnockoutObservable<string>;
    ValidMonthFrom: KnockoutObservableArray<number>;
    ValidYearFrom: KnockoutObservableArray<number>;
    BillingText: KnockoutObservable<string>;
    ConfigurationItemIsCustomer: KnockoutObservable<boolean> = ko.observable(false);
    initInProgress: Boolean = true;
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        this.Dialog.Width("750px");
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
        if (this.Dialog.ViewModel().Parent.ConfigurationItem.ConfigurationItemTypeCategoryKey() == "Customer") {
            this.ConfigurationItemIsCustomer(true);
            this.CustomerId(this.Dialog.ViewModel().Parent.ConfigurationItem.ConfigurationItemId());
        }
        else {
            this.ConfigurationItemIsCustomer(false);
            this.CustomerId(this.Dialog.ViewModel().Parent.ConfigurationItem.CustomerId());
        }
        this.SelectedAccountAssignmentType.subscribe((item) => {
            if (!this.initInProgress) {
                if (item != null) {
                    this.AccountAssignmentTypeId(item.Key);
                    this.AccountAssignmentTypeName(item.Value);
                }
                else {
                    this.AccountAssignmentTypeId(null);
                    this.AccountAssignmentTypeName("");
                }
            }
        });
        this.Price.subscribe(() => {
            if (this.Price != null && this.Amount != null) {
                this.TotalPrice(this.Price() * this.Amount());
            }
            else {
                this.TotalPrice(null);
            }
        });
        this.Amount.subscribe(() => {
            if (this.Price != null && this.Amount != null) {
                this.TotalPrice(this.Price() * this.Amount());
            }
            else {
                this.TotalPrice(null);
            }
        });
    }
    //Dummy
    SearchServiceCategory = () => { };
    ServiceCategorySearched = (item: any) => {
        if (item != null) {
            this.BillingTypeName(item.BillingTypeName);
            this.BillingTypeId(item.BillingTypeId);
            this.ServiceLevelAgreementName(item.ServiceLevelAgreementName);
            this.ServiceLevelAgreementId(item.ServiceLevelAgreementId);
            this.ServiceProviderName(item.ServiceProviderName);
            this.ServiceProviderId(item.ServiceProviderId);
            this.ServiceCategoryName(item.ServiceCategoryName);
            this.ServiceCategoryId(item.ServiceCategoryId);
            this.RealAmount(item.RealAmount);
        }
    };
    BillingTypeDeleted = () => {
        this.ClearServiceLevelAgreement();
        this.ClearServiceProvider();
        this.ClearServiceCategory();
    };
    BillingTypeChanged = () => {
        this.ClearServiceLevelAgreement();
        this.ClearServiceProvider();
        this.ClearServiceCategory();
    };
    ServiceLevelAgreementDeleted = () => {
        this.ClearServiceProvider();
        this.ClearServiceCategory();
    };
    ServiceLevelAgreementChanged = () => {
        this.ClearServiceProvider();
        this.ClearServiceCategory();
    };
    ServiceProviderDeleted = () => {
        this.ClearServiceCategory();
    };
    ServiceProviderChanged = () => {
        this.ClearServiceCategory();
    };
    ServiceLevelAgreementServiceCategoryChanged = (item: any) => {
        //Felder Preis und Real-Amount setzen
        if (item != null) {
            this.ServiceCategoryId(item.ServiceCategoryId);
            this.ServiceCategoryName(item.ServiceCategoryName);
            this.ActivityNumber(item.ActivityNumber);
            this.RealAmount(item.RealAmount);
            this.Price(item.Price);
            this.Amount(item.Amount);
        }
        else {
            this.ActivityNumber("");
            this.RealAmount(null);
            this.Price(null);
            this.Amount(null);
        }
    };
    ClearServiceLevelAgreement() {
        this.ServiceLevelAgreementName("");
        this.ServiceLevelAgreementId(null);
    }
    ClearServiceProvider() {
        this.ServiceProviderName("");
        this.ServiceProviderId(null);
    }
    ClearServiceCategory() {
        this.ServiceCategoryName("");
        this.ServiceCategoryId(null);
    }
    loadYears() {
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            for (var r in result) {
                this.YearCollection.push(result[r].Key);
            }
        });
    }
    loadMonths() {
        return Bao.post("SynosetMasterData/GetMonthCollection", JSON.stringify({}), (result) => {
            for (var r in result) {
                this.MonthCollection.push(result[r].Key);
            }
            ;
        });
    }
    loadAccountAssignmentTypes() {
        return Bao.post("SynosetMasterData/GetAccountAssignmentTypeCollection", JSON.stringify({}), (result) => {
            for (var r in result) {
                this.AccountAssignmentTypeCollection.push(result[r]);
            }
            ;
        });
    }
    loadFilter() {
        return this.loadYears().then(() => {
            return this.loadMonths().then(() => {
                return this.loadAccountAssignmentTypes();
            });
        });
    }
    loaded() {
        this.initInProgress = false;
        if (this.AccountAssignmentTypeId() != null) {
            for (var r in this.AccountAssignmentTypeCollection()) {
                if (this.AccountAssignmentTypeId() == this.AccountAssignmentTypeCollection()[r].Key) {
                    this.SelectedAccountAssignmentType(this.AccountAssignmentTypeCollection()[r]);
                }
            }
            ;
        }
    }
    init() {
        var def = $.Deferred();
        this.loadFilter().then(() => {
            def.resolve();
        });
        return def.promise();
    }
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        let result = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.BillingTypeId())) {
            result = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.ServiceLevelAgreementId())) {
            result = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.ServiceProviderId())) {
            result = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.ServiceCategoryId())) {
            result = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.BillingRhythmId())) {
            result = false;
        }
        if (this.ValidYearFrom() == null) {
            result = false;
        }
        if (this.ValidMonthFrom() == null) {
            result = false;
        }
        if (this.Amount() == null) {
            result = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(this.BillingText())) {
            result = false;
        }
        if (this.ConfigurationItemIsCustomer()) {
            if (Bao.Utils.String.IsNullOrWhitespace(this.AccountAssignmentTypeId())) {
                result = false;
            }
            if (Bao.Utils.String.IsNullOrWhitespace(this.AccountAssignment())) {
                result = false;
            }
        }
        if (!result) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        def.resolve(result);
        return def.promise();
    };
}
export default ServiceComponentDialogViewModel;